import { CoinsProvider } from './../../providers/coins/coins';
import { Coin } from './../../models/Coin';
import { Component, Input, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';

/**
 * Generated class for the CoinChartCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'coin-chart-card',
  templateUrl: 'coin-chart-card.html'
})
export class CoinChartCardComponent {
  @ViewChild('chartCard') chartCard: ElementRef;
  @Input('coin') coin: Coin;
  @Output('change') change: EventEmitter<number> = new EventEmitter<number>();
  chartWidth: number;
  interval: string = 'day';
  prevInterval: string = null; //Used for checkin last chart interval so we only re-load when necessary
  data: any[] = [];
  currency: string;

  constructor(private CP: CoinsProvider) {

  }

  ngOnInit(){
    this.chartWidth = this.chartCard.nativeElement.clientWidth;
  }

  getchartData(): any[]{
    //Probably a better way to do this with the conditionals
    if(this.prevInterval != this.interval || this.currency != this.CP.getCurrency()){

      if(this.prevInterval != this.interval) this.prevInterval = this.interval;
      if(this.currency != this.CP.getCurrency()) this.currency = this.CP.getCurrency();

      this.CP.getDynamicChart(this.coin, this.interval).subscribe(data => {
        this.data = [
          {
            "name": this.coin.Name,
            "series": data
          }
        ];
        this.getPercentChange(data);
      })
    }

    return this.data;
  }

  getPercentChange(data): number{
    let pct = 0;
    if(data && data.length > 1){
      const first = data[0].value;
      const last = data[data.length - 1].value;
      pct = (last - first) / first * 100;
    }
    this.change.emit(pct);
    return pct;
  }
}



// WEBPACK FOOTER //
// ./src/components/coin-chart-card/coin-chart-card.ts